import type { EchoflicksVideoSession } from "../types";
import { EchoList } from "./EchoList";
import { EchoflicksSessionList } from "./EchoflicksSessionList";
import { EchoflicksSessionShow } from "./EchoflicksSessionShow";

export const echoes = {
  list: EchoList,
  show: EchoflicksSessionShow,
  recordRepresentation: (record: EchoflicksVideoSession) =>
    record?.movie_title ?? record?.script_title ?? record?.session_id ?? "Echo",
};

export const videoSessions = {
  list: EchoflicksSessionList,
  show: EchoflicksSessionShow,
  recordRepresentation: (record: EchoflicksVideoSession) =>
    record?.movie_title ??
    record?.script_title ??
    record?.session_id ??
    "Video session",
};

export default videoSessions;
